export const navigation = [
  { title: "Home", link: "/" },
  { title: "About us", link: "/about-us" },
  {
    title: "Academics",
    submenu: [
      { title: "Academic Calendar", link: "/academics/academic-calendar" },
      {
        title: "Committee cell",
        submenu: [
          {
            title: "Gender Harassment Committee",
            link: "/committee/gender-harasement",
          },
          { title: "Anti Ragging Committee", link: "/committee/anti-ragging" },
          {
            title: "Curriculum Committee - 2025",
            link: "/committee/curriculum-committee",
          },
          {
            title: "hospital Infection Control Committee",
            link: "/committee/hospital-infection-control",
          },
          {
            title: "Pharmacovigilance Committee",
            link: "/committee/Pharmacovigilance",
          },
          { title: "Ethics committee", link: "/committee/ethics-committee" },
          {
            title: "Research committee",
            link: "/committee/research-committee",
          },
          { title: "College council", link: "/committee/college-council" },
          {
            title: "Enabling Unit for PwBD",
            link: "/committee/enabling-unit-pwbd",
          },
        ],
      },
      {
        title: "Fee Structure",
        submenu: [
          { title: "Tuition Fee", link: "/fee/tuition-fee" },
          { title: "Hostel Fee", link: "/fee/hostel-fee" },
        ],
      },
      {
        title: "DHR",
        link: `/view-document.html?file=${encodeURIComponent("/assets/document/academics/DHR.pdf")}`,
        target: "_blank",
        rel: "noopener noreferrer",
      },
    ],
  },
  {
    title: "Courses",
    submenu: [{ title: "MBBS", link: "/courses-mbbs" }],
  },
  {
    title: "Departments",
    submenu: [
      { title: "Anatomy", link: "/department/anatomy" },
      { title: "BioChemistry", link: "/department/bio-chemistry" },
      { title: "Physiology", link: "/department/physiology" },
      { title: "Pharmacology", link: "/department/pharmacology" },
      { title: "Pathology", link: "/department/pathology" },
      {
        title: "Forensic Medicine & Toxicology",
        link: "/department/forensic-medicine",
      },
      { title: "General medicine", link: "/department/general-medicine" },
      { title: "pediatrics", link: "/department/pediatrics" },
      { title: "Dermatology", link: "/department/dermatology" },
      { title: "Psychiatry", link: "/department/psychiatry" },
      { title: "Anaesthesiology", link: "/department/anaesthesiology" },
      { title: "general surgery", link: "/department/general-surgery" },
      { title: "Obstetrics & Gynaecology", link: "/department/obstetrics" },
      {
        title: "Oto-Rhino-Laryngology",
        link: "/department/otorhinolaryngology",
      },
      { title: "orthopedics", link: "/department/orthopedics" },
      { title: "Ophthalmology", link: "/department/ophthalmology" },
      { title: "Radio-diagnosis", link: "/department/radio-diagnosis" },
      { title: "Dentistry", link: "/department/dentistry" },
      {
        title: "Physical medicine & Rehabilitation",
        link: "/department/physical-medicine-rehabilitation",
      },
      { title: "Diagnostic Services", link: "/department/diagnostics" },
      { title: "Community medicine", link: "/department/community-medicine" },
      { title: "Microbiology", link: "/department/microbiology" },
      { title: "Emergency medicine", link: "/department/emergency-medicine" },
      { title: "Pulmonory medicine", link: "/department/pulmonory-medicine" },
    ],
  },
  {
    title: "Admin & Faculty Details",
    submenu: [
      { title: "Dean & MS", link: "/dean" },
      { title: "Faculty", link: "/faculty" },
    ],
  },
];
